import * as React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { BlogArticleDto } from "api";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import dayjs from "dayjs";

import { styles } from "./styles";

interface ArticleCardProps {
  article: BlogArticleDto;
}

const ArticleCard: React.FC<ArticleCardProps> = (props) => {
  const { article } = props;
  const { id, title, imageUrl, publishedDate, readingTimeMinutes, url } =
    article;

  const publishedDateFormatted = dayjs(publishedDate).format("DD MMM. YYYY");

  const onReadArticleClick = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.iban_oplata_blog_read_article,
      { id },
      true,
    );

    url && window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Stack sx={styles.article} onClick={onReadArticleClick}>
      <Box sx={styles.imgWrapper}>
        <img src={imageUrl ?? ""} alt={title ?? ""} style={styles.img} />
      </Box>
      <Typography variant="body2" color="text.secondary">
        {publishedDateFormatted} • Читати {readingTimeMinutes} хв
      </Typography>
      <Typography variant="h3" color="text.secondary" sx={styles.title}>
        {title}
      </Typography>
    </Stack>
  );
};

export default ArticleCard;
